// web/src/features/competition/wizard/hooks/useCreateCompetition.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createCompetition,
  CreatedCompetition,
} from '@sportninja/common/services/competition'
import type { CreateCompetitionRequest } from '@sportninja/common/features/competition/wizard/types'
import { queryKeys } from '@sportninja/common/config/queryKeys'

type Vars = { orgId: string; body: CreateCompetitionRequest }

export const useCreateCompetition = () => {
  const queryClient = useQueryClient()
  return useMutation<CreatedCompetition, Error, Vars>({
    mutationFn: ({ orgId, body }) => createCompetition(orgId, body),
    // Override the global mutations.retry=1 default (see queryClient config).
    // Create is non-idempotent — a retry can silently duplicate the competition.
    retry: 0,
    onSuccess: (_data, { orgId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.orgCompetitions.byOrg(orgId),
      })
    },
  })
}
